const phoneCapture: RegExp = /(\d)+/g;

// Takes into account the country code i.e. 1 for US
export function isValid (phone: string): boolean {
    const digits = parse(phone);
    return digits.length >= 10 && digits.length <= 11;
}

// returns phone number without the hyphen
export function parse (phone: string): string {
    let digits = "";

    if (!phone) {
      return digits;
    }

    for (let match = phoneCapture.exec(phone); match; match = phoneCapture.exec(phone)) {
      digits += match[0];
    }

    return digits;
  }

  export function format (phone: string): string {
    if (!phone) {
      return "";
    }

    const phoneTrimmed = phone.trim();
    const phoneLength = phoneTrimmed ? phoneTrimmed.length : 0;

    if (phoneLength === 10) {
      const areaCode = phoneTrimmed.slice(0, 3);
      const second = phoneTrimmed.slice(3, 6);
      const third = phoneTrimmed.slice(6, 10);
      return `${areaCode}-${second}-${third}`;
    }
    return phoneTrimmed;
  }